/**
 * UI Component Constants
 * Constants specific to dashboard UI components and view states
 */

// Timed EntryDashboard view constants - used by dashboard components for view state management
export const LIST_VIEW = 'LIST_VIEW' as const;
export const WEEK_VIEW = 'WEEK_VIEW' as const;

// Dashboard view constants
export const SINGLE_EVENT_VIEW = 'SINGLE_EVENT_VIEW' as const;
export const TIMED_ENTRY_VIEW = 'TIMED_ENTRY_VIEW' as const;
